export default __webpack_public_path__ + "static/media/chat.584566fe.svg";